export const validateHost = (host: string): boolean => {
	try {
		const url = new URL('https://' + host);
		return host === url.host;
	}
	catch {
		return false;
	}
};
